import { FC } from 'react';
import { clsx } from 'clsx';

import { IHeaderGroupExamsRowTableSchedule } from '../models/IHeaderGroupExamsRowTableSchedule';

import styles from './styles.module.scss';

export const HeaderGroupExamsRowTableSchedule: FC<
  IHeaderGroupExamsRowTableSchedule
> = ({ isScrolled }) => {
  return (
    <div
      className={clsx(styles['table-schedule-row'], {
        [styles['table-schedule-row_scrolled']]: isScrolled,
      })}
    >
      <div className={styles['table-schedule-cell']}>Дата</div>
      <div className={styles['table-schedule-cell']}>Время</div>
      <div className={styles['table-schedule-cell']}>Дисциплина</div>
      <div className={styles['table-schedule-cell']}>Аудитория и здание</div>
      <div className={styles['table-schedule-cell']}>Преподаватель</div>
    </div>
  );
};
